module.exports = __webpack_public_path__ + "static/media/rBullPat.ef80fd53.png";